import $http from './http';

//登录
export const submitLogin = data => {
    return $http.post('/v1/login/login', data);
};

// 退出系统
export const logout = data => {
    return $http.post('/v1/system/logout', data);
    // $http.post('/logout', data).then(()=>{
    //     location.href = `${process.env.VUE_APP_AUTH_URL}/user/login?redirect=${encodeURIComponent(location.href)}&_f=1`;
    // });
};


// 组织架构
export const depart = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/depart/' + id : '/v1/depart',
        method == 'get' ? { params: params } : params
    );
};

// 组织架构信息
export const architecture = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/depart/architecture/' + id : '/v1/depart/architecture',
        method == 'get' ? { params: params } : params
    );
};

// 天气
export const weather = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/system/weather/' + id : '/v1/system/weather',
        method == 'get' ? { params: params } : params
    );
};

// 获取用户头像 
export const userAvatar = (name,size=100) => {
    return $http[`get`](
        `https://uc-api.loratech.cn/dingtalk/2/user/${name}/avatar/${size}`
    );
};

// oss图片上传
export const ossImageUpload = () => {
    return $http[`get`](
        `https://oss.loratech.cn/upload-token`
    );
};